enum FileExtension {
  Excel = 'xlsx',
  Pdf = 'pdf',
  Csv = 'csv',
}

enum FileMimeType {
  Excel = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  Pdf = 'application/pdf',
  Csv = 'text/csv',
}

export { FileExtension, FileMimeType };
